
import getronics from 'assets/brand-logos/getronics-logo.svg'
import bnpLogo from 'assets/brand-logos/bnp-logo.svg'
import heinekenLogo from 'assets/brand-logos/heineken-logo.svg'

const appLogos = {
    getronics: getronics,
    bnpLogo: bnpLogo,
    heinekenLogo: heinekenLogo,
    default: getronics
}

export {
    appLogos
}